(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-cross-sell"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('matty-cart-addons')) {
    customElements.define('matty-cart-addons', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-cx-add]');
          if (button && this.contains(button)) this.addItem(button);
        }, options);
        window.addEventListener('baseline:cart:afteradditem', event => {
          const response = event.detail?.response;
          const items = response?.items || (response ? [response] : []);
          const ids = items.map(item => String(item.product_id));
          this.querySelectorAll('[data-product-id]').forEach(card => {
            if (ids.includes(card.dataset.productId)) card.remove();
          });
          if (!this.querySelector('.cx-card')) this.hidden = true;
          this.syncShipping(response);
        }, options);
        ['baseline:cart:cartqtychange', 'baseline:cart:update'].forEach(name => {
          window.addEventListener(name, event => {
            this.syncShipping(event.detail?.response);
            this.querySelector('[data-cx-status]').textContent = '';
          }, options);
        });
        this.syncShipping();
      }
      syncShipping(response) {
        const html = response?.sections?.['cart-items'];
        const source = html ? new DOMParser().parseFromString(html, 'text/html') : this.closest('[data-cart-drawer]');
        const meter = source?.querySelector('[data-fsm]');
        const remaining = Number(meter?.dataset.shippingRemaining || 0);
        const enabled = meter?.dataset.shippingUpsell === 'true' && remaining > 0;
        this.querySelectorAll('[data-shipping-price]').forEach(card => {
          const note = card.querySelector('[data-cx-shipping]');
          note.hidden = !(enabled && Number(card.dataset.shippingPrice) >= remaining);
        });
      }
      async addItem(button) {
        if (button.disabled) return;
        const status = this.querySelector('[data-cx-status]');
        button.disabled = true;
        button.textContent = this.dataset.addingLabel;
        status.textContent = '';
        const body = new FormData();
        body.append('id', button.dataset.variantId);
        body.append('quantity', '1');
        body.append('sections', 'cart-items,cart-footer,cart-item-count,cart-live-region');
        body.append('sections_url', window.location.pathname);
        try {
          const response = await fetch(window.theme?.routes?.cart_add_url || '/cart/add', {
            method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || 'Add failed');
          document.body.dispatchEvent(new CustomEvent('baseline:cart:afteradditem', {
            bubbles: true, detail: { response: data, sourceId: 'cart-cross-sell' }
          }));
          status.textContent = this.dataset.addedLabel;
          this.querySelector('[data-cx-add], .cx-card-add')?.focus({ preventScroll: true });
        } catch {
          status.textContent = this.dataset.errorLabel;
          button.disabled = false;
          button.textContent = this.dataset.addLabel;
        }
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-cable-bundle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('matty-cable-bundle')) {
    customElements.define('matty-cable-bundle', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = {signal:this.abort.signal};
        this.form = this.querySelector('form');
        this.button = this.querySelector('button[type="submit"]');
        this.action = this.querySelector('[data-bundle-action]');
        this.actionLabel = this.action.textContent;
        this.status = this.querySelector('[data-bundle-status]');
        this.bulkPanel = this.querySelector('[data-bulk-panel]');
        this.bulkToggle = this.querySelector('[data-bulk-toggle]');
        this.bulkBack = this.querySelector('[data-bulk-back]');
        this.bulkInputs = Array.from(this.querySelectorAll('[data-bulk-quantity]'));
        this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:'USD',minimumFractionDigits:0,maximumFractionDigits:2});
        this.querySelectorAll('[name="bundle_quantity"]').forEach(input => {input.disabled=false;});
        this.addEventListener('change', event => {
          if (event.target.name==='bundle_quantity') this.bulkMode=false;
          this.status.textContent='';this.sync();
        }, options);
        this.addEventListener('input', event => {
          if (event.target.matches('[data-bulk-quantity]')) {this.status.textContent='';this.sync();}
        }, options);
        this.bulkToggle.addEventListener('click', () => this.openBulk(), options);
        this.bulkBack.addEventListener('click', () => {
          this.bulkMode=false;
          this.sync();
          this.bulkToggle.focus();
        }, options);
        this.querySelectorAll('[data-quantity-step]').forEach(button => button.addEventListener('click', () => {
          const input=button.closest('[data-quantity-row]').querySelector('[data-bulk-quantity]');
          const current=Number(input.value);
          input.value=String(Math.max(0,(Number.isSafeInteger(current)?current:0)+Number(button.dataset.quantityStep)));
          this.status.textContent='';this.sync();
        }, options));
        this.form.addEventListener('submit', event => {event.preventDefault();this.add();}, options);
        this.sync();
      }
      openBulk() {
        if (this.busy) return;
        const items=this.items();
        const last=Array.from(items.keys()).at(-1);
        if (last) items.set(last,items.get(last)+4-Array.from(items.values()).reduce((sum,n)=>sum+n,0));
        this.bulkInputs.forEach(input=>{input.value=String(items.get(input.dataset.variantId)||0);});
        this.bulkMode=true;
        this.status.textContent='';this.sync();
        this.bulkInputs.find(input=>!input.disabled)?.focus();
      }
      items() {
        const items=new Map();
        if (this.bulkMode) {
          this.bulkInputs.forEach(input=>{
            const n=Number(input.value);
            if (input.dataset.available!=='false' && Number.isSafeInteger(n) && n>0) items.set(input.dataset.variantId,n);
          });
        } else {
          const count=Number(this.querySelector('[name="bundle_quantity"]:checked').value);
          Array.from(this.querySelectorAll('[data-cable-color]')).slice(0,count).forEach(row=>{
            const input=row.querySelector('[data-color-choice]:checked');
            if (input && input.dataset.available!=='false') items.set(input.value,(items.get(input.value)||0)+1);
          });
        }
        return items;
      }
      purchaseState() {
        const items=Array.from(this.items(),([id,quantity])=>({id:Number(id),quantity}));
        const count=items.reduce((sum,item)=>sum+item.quantity,0);
        // Shopify automatic discounts take a fixed amount off each cable.
        const discount=count>=3?400:count===2?200:0;
        const prices=new Map(this.bulkInputs.map(input=>[Number(input.dataset.variantId),Number(input.dataset.unitPrice)]));
        const subtotal=items.reduce((sum,item)=>sum+prices.get(item.id)*item.quantity,0);
        const saving=items.reduce((sum,item)=>sum+Math.min(prices.get(item.id),discount)*item.quantity,0);
        const valid=Number.isSafeInteger(subtotal) && subtotal>=0 && Number.isSafeInteger(count) && count>0 && (!this.bulkMode || this.bulkInputs.every(input=>input.dataset.available==='false' || (input.value!=='' && Number.isSafeInteger(Number(input.value)) && Number(input.value)>=0)));
        return {items,subtotal,saving,valid};
      }
      sync() {
        const selected = this.querySelector('[name="bundle_quantity"]:checked');
        const state=this.purchaseState();
        const count=state.items.reduce((sum,item)=>sum+item.quantity,0);
        const total=(state.subtotal-state.saving)/100;
        const valid=state.valid;
        if (this.bulkMode && count>0) this.querySelector(`[name="bundle_quantity"][value="${Math.min(3,count)}"]`).checked=true;
        this.bulkPanel.hidden=!this.bulkMode;
        this.bulkToggle.hidden=!!this.bulkMode;
        this.bulkToggle.setAttribute('aria-expanded',String(!!this.bulkMode));
        this.bulkToggle.disabled=!!this.busy;
        this.bulkBack.disabled=!!this.busy;
        this.querySelector('.cable-bundle__colors').hidden=!!this.bulkMode;
        this.querySelectorAll('[name="bundle_quantity"]').forEach(input=>{input.disabled=!!this.busy;});
        this.querySelectorAll('[data-cable-color]').forEach((row,index) => {
          row.hidden=!!this.bulkMode || index>=Number(selected.value);
          row.querySelectorAll('input').forEach(input => {input.disabled=row.hidden || !!this.busy || input.dataset.available==='false';});
          const choice=row.querySelector('[data-color-choice]:checked');
          row.querySelector('span[data-color-name]').textContent=choice?.dataset.colorName || '';
        });
        this.bulkInputs.forEach(input=>{
          input.disabled=!this.bulkMode || !!this.busy || input.dataset.available==='false';
          input.closest('[data-quantity-row]').querySelectorAll('[data-quantity-step]').forEach(button=>{
            button.disabled=input.disabled || (Number(button.dataset.quantityStep)<0 && !(Number(input.value)>0));
          });
        });
        this.querySelector('[data-bundle-total]').textContent=this.money.format(total);
        this.dataset.quantityLabel=count===1?this.dataset.one:this.dataset.many.replace('[count]',String(count));
        this.querySelector('[data-bulk-summary]').textContent=valid?this.dataset.summary.replace('[quantity]',this.dataset.quantityLabel).replace('[amount]',this.money.format(total)):this.dataset.empty;
        this.button.disabled=!!this.busy || !valid;
        this.dispatchEvent(new CustomEvent('matty:bundle:change'));
      }
      async add() {
        if (this.busy || !this.form.reportValidity()) return;
        const items = this.items();
        if (!items.size || this.button.disabled) return;
        this.busy=true;
        this.button.disabled=true;
        this.button.setAttribute('aria-busy','true');
        this.action.textContent=this.dataset.adding;
        this.status.textContent='';
        this.querySelectorAll('input[type="radio"]').forEach(input => {input.disabled=true;});
        this.sync();
        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
            body:JSON.stringify({items:Array.from(items,([id,quantity])=>({id:Number(id),quantity})),sections:'cart-items,cart-footer,cart-item-count,cart-live-region',sections_url:window.location.pathname})
          });
          const data=await response.json();
          if (!response.ok || data.status) throw new Error(data.description || this.dataset.error);
          if (!data.sections || Object.values(data.sections).some(section=>!section)) {
            window.location.assign(`${window.Shopify.routes.root}cart`);
            return;
          }
          document.body.dispatchEvent(new CustomEvent('baseline:cart:afteradditem',{bubbles:true,detail:{response:data,sourceId:this.form.id}}));
          this.status.textContent=this.dataset.added;
        } catch(error) {
          this.status.textContent=error.message || this.dataset.error;
        } finally {
          this.busy=false;
          this.button.disabled=false;
          this.button.removeAttribute('aria-busy');
          this.action.textContent=this.actionLabel;
          this.querySelectorAll('input[type="radio"]').forEach(input=>{input.disabled=false;});
          this.sync();
        }
      }
      disconnectedCallback() {this.abort?.abort();}
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-good-company"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('matty-good-company')) {
    customElements.define('matty-good-company',class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort=new AbortController();
        this.root=this.closest('[data-product-root]') || this.closest('section') || this.parentElement;
        this.cable=this.closest('matty-cable-bundle');
        this.cards=Array.from(this.querySelectorAll('[data-pair-card]')).map(el=>({el,check:el.querySelector('[data-pair-check]'),variants:JSON.parse(el.querySelector('[data-pair-variants]').textContent),saving:Number(el.dataset.saving)||0,offerSaving:Number(el.dataset.offerSaving)||0}));
        this.form=document.getElementById(this.dataset.form);
        this.button=this.querySelector('[data-pair-submit]') || this.form?.querySelector('.cable-bundle__add');
        this.status=this.querySelector('[data-pair-status]');
        this.money=new Intl.NumberFormat(document.documentElement.lang || 'en',{style:'currency',currency:'USD'});
        const opts={signal:this.abort.signal};
        this.cards.forEach(({el})=>{
          const toggle=el.querySelector('[data-pair-toggle]');
          toggle?.addEventListener('click',()=>toggle.setAttribute('aria-expanded',String(toggle.getAttribute('aria-expanded')!=='true')),opts);
        });
        this.form?.addEventListener('submit',event=>{
          if(!this.cards.some(card=>card.check.checked))return;
          event.preventDefault();event.stopImmediatePropagation();
          this.add(this.form);
        },{...opts,capture:true});
        this.root.addEventListener('input',()=>this.sync(),opts);
        this.root.addEventListener('change',()=>this.sync(),opts);
        this.cable?.addEventListener('matty:bundle:change',()=>this.sync(),opts);
        this.observer=new MutationObserver(()=>this.schedule());
        this.observer.observe(this.root,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['disabled','value','class']});
        this.querySelector('[data-pair-ui]').hidden=false;
        this.sync();
      }
      schedule(){if(this.frame)return;this.frame=requestAnimationFrame(()=>{this.frame=0;this.sync();});}
      state(){
        const form=document.getElementById(this.dataset.form);
        const cards=this.cards.map(card=>{
          const id=card.el.querySelector('input[type="radio"]:checked')?.value;
          return {...card,variant:card.variants.find(v=>String(v.id)===id) || card.variants.find(v=>v.available)};
        });
        const selected=cards.filter(card=>card.check.checked);
        let purchase;
        if(this.cable?.bulkInputs){purchase=this.cable.purchaseState?.();}
        else if(form && !this.cable){
          const id=form.querySelector('[name="id"]')?.value;
          let main;
          try{main=JSON.parse(this.root.querySelector('[data-current-variant]')?.textContent || 'null');}catch{main=null;}
          const values=new FormData(form);
          const quantity=Number(values.get('quantity') || 1);
          const properties={};
          for(const [key,value] of values.entries()){
            const match=key.match(/^properties\[(.+)\]$/);
            if(match && typeof value==='string')properties[match[1]]=value;
          }
          const item={id:Number(id),quantity};
          if(Object.keys(properties).length)item.properties=properties;
          const plan=values.get('selling_plan');if(plan)item.selling_plan=plan;
          const original=form.querySelector('button.add-to-cart');
          purchase={items:[item],subtotal:(main?.price || 0)*quantity,saving:0,valid:!!main?.available && String(main.id)===id && Number.isSafeInteger(quantity) && quantity>0 && !original?.disabled};
        }
        return {form,cards,selected,purchase,valid:!!purchase?.valid && selected.every(card=>card.variant?.available)};
      }
      totals(s){
        const subtotal=s.purchase.subtotal+s.selected.reduce((sum,card)=>sum+card.variant.price,0);
        const saving=Math.max(s.purchase.saving,...s.selected.map(card=>Math.min(card.offerSaving,s.purchase.subtotal+card.variant.price)));
        return Math.max(0,subtotal-saving);
      }
      sync(){
        const s=this.state();if(!s.form || !s.purchase || !this.button)return;
        const selected=s.selected.length>0;
        this.toggleAttribute('data-selected',selected);
        if(!this.cable && this.button.hidden===selected)this.button.hidden=!selected;
        const disabled=!!this.busy || !!this.uncertain || !!this.cable?.busy || !s.valid;
        if(this.button.disabled!==disabled)this.button.disabled=disabled;
        const price=this.money.format(this.totals(s)/100);
        this.dataset.total=price;
        this.dataset.summary=this.dataset.summaryTemplate.replace('[products]',s.selected.map(card=>card.el.dataset.title).join(' + '));
        const set=(root,selector,text)=>{const el=root.querySelector(selector);if(el && el.textContent!==text)el.textContent=text;};
        set(this,'[data-pair-total]',price);
        set(this,'[data-pair-action]',this.busy?this.dataset.adding:this.dataset.add);
        if(this.cable){
          set(this.cable,'[data-bundle-total]',price);
          set(this.cable,'[data-bundle-action]',this.busy || this.cable.busy?this.dataset.adding:selected?this.dataset.add:this.cable.actionLabel);
        }
        s.cards.forEach(card=>{
          const v=card.variant;if(!v)return;
          const amount='+'+this.money.format(Math.max(0,v.price-card.saving)/100);
          card.el.toggleAttribute('data-selected',card.check.checked);
          set(card.el,'[data-pair-price]',amount);set(card.el,'[data-pair-original]',this.money.format(v.price/100));set(card.el,'[data-pair-color]',v.title);
          const toggle=card.el.querySelector('[data-pair-toggle]');
          if(toggle){
            set(card.el,'[data-pair-toggle-label]',card.check.checked?toggle.dataset.selectedLabel:toggle.dataset.label);
            set(card.el,'[data-pair-selection]',(v.title==='Default Title'?'':v.title+' · ')+amount);
          }
          const img=card.el.querySelector('.matty-pair__image img');
          if(img && img.getAttribute('src')!==v.image){img.removeAttribute('srcset');img.src=v.image;}
          card.el.querySelectorAll('input').forEach(input=>{const busy=!!this.busy || !!this.cable?.busy;if(input.disabled!==busy)input.disabled=busy;});
        });
      }
      async add(form){
        const s=this.state();if(this.busy || this.uncertain || !s.selected.length || !s.valid || !form.reportValidity())return;
        const items=[...s.purchase.items,...s.selected.map(card=>({id:card.variant.id,quantity:1}))];
        this.busy=true;this.status.textContent='';this.button.setAttribute('aria-busy','true');
        if(this.cable){this.cable.busy=true;this.cable.sync();}
        this.sync();
        try{
          const response=await fetch(`${window.Shopify.routes.root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items,sections:'cart-items,cart-footer,cart-item-count,cart-live-region',sections_url:window.location.pathname})});
          const data=await response.json();
          if(!response.ok || data.status){this.uncertain=true;throw new Error(data.description || this.dataset.error);}
          if(!data.sections || Object.values(data.sections).some(value=>!value)){window.location.assign(`${window.Shopify.routes.root}cart`);return;}
          document.body.dispatchEvent(new CustomEvent('baseline:cart:afteradditem',{bubbles:true,detail:{response:data,sourceId:form.id}}));
          this.status.textContent=this.dataset.added;
        }catch(error){this.uncertain=true;this.status.textContent=(error.message && error.message!=='Failed to fetch'?error.message+' ':'')+this.dataset.error;this.querySelector('[data-pair-cart]').hidden=false;}
        finally{this.busy=false;this.button.removeAttribute('aria-busy');if(this.cable){this.cable.busy=false;this.cable.sync();}this.sync();}
      }
      disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();cancelAnimationFrame(this.frame);}
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-story-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('matty-story-video')) {
    customElements.define('matty-story-video', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.trigger = this.querySelector('[data-story-watch]');
        this.dialog = this.querySelector('dialog');
        this.player = this.querySelector('[data-story-player]');
        this.template = this.querySelector('[data-story-template]');
        if (!this.trigger || !this.dialog || !this.player || !this.template) return;
        this.trigger.hidden = false;
        this.preview = this.querySelector('[data-story-preview]');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.previewPaused = this.reducedMotion.matches;
        this.observer?.disconnect();
        if (this.preview) {
          this.preview.muted = true;
          this.observer = new IntersectionObserver(() => {
            this.syncPreview();
          }, { threshold: 0.25 });
          this.observer.observe(this.trigger);
          this.reducedMotion.addEventListener('change', () => {
            this.previewPaused = this.reducedMotion.matches;
            this.syncPreview();
          }, options);
          document.addEventListener('visibilitychange', () => this.syncPreview(), options);
          this.syncPreview();
        }
        const galleryRoot=this.closest('[data-product-root]');
        const galleryButtons=galleryRoot?.querySelectorAll('[data-gallery-watch]') || [];
        galleryButtons.forEach(button=>{button.hidden=false;});
        const openVideo = (event) => {
          this.returnFocus=event.currentTarget;
          if (this.dialog.open) return;
          const content = this.template.content.cloneNode(true);
          const video = content.querySelector('video');
          const reveal = content.querySelector('[data-story-controls]');
          if (video && reveal) {
            video.controls = false;
            reveal.hidden = false;
            const showControls = () => {
              video.controls = true;
              video.tabIndex = 0;
              reveal.hidden = true;
            };
            reveal.addEventListener('click', () => {
              showControls();
              video.focus({ preventScroll: true });
            }, options);
            ['pause', 'ended', 'error'].forEach(event => video.addEventListener(event, showControls, options));
          }
          this.player.replaceChildren(content);
          this.dialog.showModal();
          this.syncPreview();
          document.documentElement.classList.add('matty-story-video-open');
          if (video) {
            video.playsInline = true;
            video.load();
            video.play()?.catch(() => {
              if (video.isConnected && this.dialog.open) {
                video.pause();
                video.controls = true;
                video.tabIndex = 0;
                if (reveal) reveal.hidden = true;
              }
            });
          }
        };
        this.trigger.addEventListener('click',openVideo,options);
        galleryButtons.forEach(button=>button.addEventListener('click',openVideo,options));
        this.querySelector('[data-story-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          this.clearPlayer();
          this.syncPreview();
          (this.returnFocus || this.trigger).focus({ preventScroll: true });
        }, options);
      }
      syncPreview() {
        if (!this.preview) return;
        const rect = this.trigger.getBoundingClientRect();
        const visible = rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
        if (visible && !this.previewPaused && !document.hidden && !this.dialog.open) {
          if (!this.preview.getAttribute('src')) this.preview.src = this.preview.dataset.src;
          this.preview.play()?.catch(() => {});
        } else {
          this.preview.pause();
        }
      }
      clearPlayer() {
        this.player?.querySelectorAll('video').forEach(video => video.pause());
        this.player?.replaceChildren();
        if (!document.querySelector('.matty-story-video__dialog[open]')) document.documentElement.classList.remove('matty-story-video-open');
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.preview?.pause();
        this.controller?.abort();
        if (this.dialog?.open) this.dialog.close();
        this.clearPlayer();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-atc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('matty-sticky-purchase')) {
    customElements.define('matty-sticky-purchase', class extends HTMLElement {
      connectedCallback() {
        this.root = document.getElementById(this.dataset.root);
        if (!this.root) return;
        this.abort = new AbortController();
        const options = {signal:this.abort.signal};
        this.mobile = window.matchMedia('(max-width:749px)');
        this.button = this.querySelector('[data-sticky-add]');
        this.schedule = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = 0; this.sync(); });
        };
        this.button.addEventListener('click', () => {
          const form = document.getElementById(this.dataset.form);
          const pair = this.root.querySelector('matty-good-company[data-selected]');
          const original = pair?.querySelector('[data-pair-submit]') || form?.querySelector('button.add-to-cart');
          if (this.choose || !original || original.disabled) { this.goToOptions(); return; }
          if (!form.reportValidity()) { this.goToOptions(); return; }
          original.click();
        }, options);
        this.querySelector('[data-sticky-change]')?.addEventListener('click', () => this.goToOptions(), options);
        this.root.addEventListener('change', this.schedule, options);
        document.addEventListener('theme:variant:change', this.schedule, options);
        document.addEventListener('theme:product:error:add-to-cart', event => { if (event.detail?.formEl?.id === this.dataset.form) this.goToOptions(); }, options);
        this.root.addEventListener('baseline:productform:loading', () => { this.pending=true; this.schedule(); }, options);
        ['baseline:productform:success','baseline:productform:error'].forEach(name => this.root.addEventListener(name, () => { this.pending=false; this.schedule(); }, options));
        ['right-drawer-will-open','right-drawer-is-open','right-drawer-is-closed','left-drawer-will-open','left-drawer-is-closed'].forEach(name => document.addEventListener(name, this.schedule, options));
        window.addEventListener('scroll', this.schedule, {...options,passive:true});
        window.addEventListener('resize', this.schedule, options);
        this.mobile.addEventListener('change', this.schedule, options);
        document.addEventListener('toggle', this.schedule, {...options,capture:true});
        this.observer = new MutationObserver(this.schedule);
        this.observer.observe(this.root,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','class','value','aria-busy']});
        this.overlayObserver = new MutationObserver(this.schedule);
        [document.body,document.documentElement,document.getElementById('MainContent')].filter(Boolean).forEach(el => this.overlayObserver.observe(el,{attributes:true,attributeFilter:['class','style','inert','aria-hidden']}));
        this.sync();
      }
      goToOptions() {
        const target = this.root.querySelector('matty-cable-bundle input:checked') || this.root.querySelector('[data-product-option] input, [data-product-option] select, .product-block--variant-picker input, .product-block--variant-picker button') || this.root.querySelector('button.add-to-cart');
        const area = this.root.querySelector('matty-cable-bundle') || this.root.querySelector('.product-block--variant-picker') || document.getElementById(this.dataset.form);
        area?.scrollIntoView({block:'center',behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
        target?.focus({preventScroll:true});
      }
      sync() {
        const form = document.getElementById(this.dataset.form);
        const pair = this.root.querySelector('matty-good-company[data-selected]');
        const original = pair?.querySelector('[data-pair-submit]') || form?.querySelector('button.add-to-cart');
        if (!original || !this.mobile.matches) { this.hidden=true; return; }
        let variant;
        try { variant=JSON.parse(this.root.querySelector('[data-current-variant]')?.textContent || 'null'); } catch { variant=null; }
        const variantId=form.querySelector('[name="id"]')?.value;
        const bundle=this.root.querySelector('matty-cable-bundle');
        const ready=bundle ? true : variant && String(variant.id)===variantId;
        const changing=original.classList.contains('disabled--transient');
        this.choose=bundle ? false : !variantId || !ready;
        const busy=this.pending || changing || original.classList.contains('disabled--loading') || original.getAttribute('aria-busy')==='true';
        const unavailable=bundle ? false : ready && !variant.available;
        const text=busy ? this.dataset.adding : pair ? pair.dataset.add : this.choose ? this.dataset.choose : unavailable ? this.dataset.sold : this.dataset.add;
        if (this.button.textContent!==text) this.button.textContent=text;
        this.button.disabled=busy || unavailable || (!this.choose && original.disabled);
        this.querySelector('[data-sticky-price]').textContent=pair?.dataset.total || bundle?.querySelector('[data-bundle-total]')?.textContent.trim() || this.root.querySelector('[data-sticky-current-price]')?.textContent.trim() || '';
        this.querySelector('[data-sticky-variant]').textContent=pair ? pair.dataset.summary : bundle ? bundle.dataset.quantityLabel || bundle.querySelector('input:checked + label [data-tier-title]')?.textContent.trim() || '' : ready && variant.title!=='Default Title' ? variant.title : '';
        const overlay=document.querySelector('dialog[open]') || this.closest('[inert]') || this.root.closest('[inert]') || getComputedStyle(document.body).overflow==='hidden' || getComputedStyle(document.documentElement).overflow==='hidden';
        const title=this.root.querySelector('[data-product-title]');
        const rect=original.getBoundingClientRect();
        const buttonVisible=rect.top<window.innerHeight && rect.bottom>70;
        const past=(title?.getBoundingClientRect().bottom ?? rect.bottom)<=70 && !buttonVisible;
        this.hidden=!past || !!overlay || document.activeElement?.matches('input:not([type=radio]):not([type=checkbox]),textarea');
      }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.overlayObserver?.disconnect(); cancelAnimationFrame(this.frame); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
